var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.icon,{tag:"component",staticClass:"ntds-treecon",class:_vm.classes})}
var staticRenderFns = []

export { render, staticRenderFns }